import VehicleCard from "./VehicleCard";
import VehicleCardSkeleton from "./VehicleCardSkeleton";

export const VehicleGrid = ({ vehicles, loading }) => {
  if (loading) {
    return (
      <div
        data-testid="vehicle-grid-loading"
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10"
      >
        {Array.from({ length: 6 }).map((_, i) => (
          <VehicleCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (!vehicles || vehicles.length === 0) {
    return (
      <div
        data-testid="vehicle-grid-empty"
        className="py-20 md:py-32 flex flex-col items-center justify-center text-center"
      >
        <div className="w-12 h-12 border border-champagne/40 flex items-center justify-center mb-6">
          <span className="font-display text-champagne text-xl">&empty;</span>
        </div>
        <h3 className="font-display text-3xl md:text-4xl text-white mb-3">
          Geen voertuigen gevonden
        </h3>
        <p className="text-sm text-zinc-400 font-body max-w-md">
          Uw selectie leverde geen resultaten op. Wijzig de filters of wis de
          huidige zoekopdracht om andere voertuigen uit onze collectie te
          bekijken.
        </p>
      </div>
    );
  }

  return (
    <div
      data-testid="vehicle-grid"
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10"
    >
      {vehicles.map((v, i) => (
        <VehicleCard key={v.id} vehicle={v} index={i} />
      ))}
    </div>
  );
};

export default VehicleGrid;
